import React from 'react';
import hoc from './FieldHOC';
import HelpText from './HelpText';

class InputField extends React.Component {
  onChange(e) {
    let value = e.target.value;
    if (this.props.field.prop('currencyField')) {
      value = value.replace(',','').replace('$', '');
      if (isNaN(value) || value === '') {
        value = 0;
      }
      this.props.field.setSelectedValue(parseFloat(value));
    }
    this.props.onChange(value);
  }

  render() {
    let field = this.props.field;
    return (
      <div>
        <label htmlFor={this.props.name}>{this.props.title || field.get('title')}</label>
        <HelpText field={field} helpText={this.props.helpText} />
        {this.props.errorComponent}
        <input
          className="form-control"
          name={this.props.name}
          aria-label={this.props.title || field.get('title')}
          placeholder={field.prop('hintText')}
          tabIndex={this.props.tabIndex}
          onChange={this.onChange.bind(this)}
          value={this.props.value || ''}
          disabled={this.props.disabled}
        />
      </div>
    );
  }
}

export default hoc(InputField);
